import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, signal, WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';
import { FormioComponent } from '@formio/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { SchemaService } from '../../../shared/services/schema.service';
import { FormIoViewData } from '../../../shared/models/formio.model';
import { LoadingSpinnerBorderComponent } from "../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";
import { SchemaActionEvent } from '../../../shared/events/schema-event';
import { SchemaAction, SchemaActionStatus } from '../../../shared/enums/schema-status';
import * as bootstrap from 'bootstrap';
import { Router } from '@angular/router';
import { SchemaRepository } from '../../../shared/repositories/schema.repository';

@Component({
    selector: 'delete-schema-dialog',
    imports: [CommonModule, TranslocoModule, LoadingSpinnerBorderComponent],
    templateUrl: './delete-schema-dialog.component.html',
    styleUrl: './delete-schema-dialog.component.scss'
})
export class DeleteSchemaDialogComponent {
    private readonly schemaService = inject(SchemaService);
    private readonly schemaRepository = inject(SchemaRepository);
    private readonly router = inject(Router);

    @Input() formioInstance: FormioComponent | undefined;
    @Input() formioData!: FormIoViewData;
    @Input() isSchemaDeleting: WritableSignal<boolean> = signal(false);
    @Output() deleteSchemaEvent = new EventEmitter<SchemaActionEvent>();

    deleteSchema$: Observable<boolean> | undefined;

    onDeleteSchemaClick(): void {
        this.isSchemaDeleting.set(true);
        this.schemaService.postDeleteSchema$(this.formioData.schemaId).subscribe({
            next: (result: boolean) => {
                this.deleteSchemaEvent.emit({
                    action: SchemaAction.DELETE,
                    status: result ? SchemaActionStatus.SUCCESS : SchemaActionStatus.ERROR,
                    text: result ? "schema.deleteschema.successtext" : "schema.deleteschema.errortext"
                });
                this.showToast();
            },
            error: () => {
                this.deleteSchemaEvent.emit({
                    action: SchemaAction.DELETE,
                    status: SchemaActionStatus.ERROR,
                    text: "schema.deleteschema.errortext"
                });
                this.showToast();
                this.isSchemaDeleting.set(false);
            },
            complete: () => {
                this.schemaRepository.updateSchemaStoreByDelete(this.formioData.schemaId);
                this.isSchemaDeleting.set(false);
                this.onSchemaDeletedRoute();
            }
        })
    }

    showToast() {
        const toastEl: HTMLElement = document.getElementById('deleteSchemaToast')!;
        const toast = new bootstrap.Toast(toastEl);
        toast.show();
    }

    onSchemaDeletedRoute(): void {
        setTimeout(() => {
            this.router.navigate(['/schemas']);
        }, 2000);
    }
}
